/**
 * 系统管理  公司管理
 */
<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleOrg()">添加组织</el-button>
      </el-form-item>
    </el-form>

    <!-- 组织列表 -->
    <el-tabs v-if="listData && listData.length > 0" v-model="activeName" type="card" editable @edit="handleTabsDelete" @tab-click="handleClick">
      <el-tab-pane v-for="item in listData" :key="item.id" :label="item.name" :name="item.organizationId.toString()">
        <el-tag>描述：{{item.description}}</el-tag>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="editDeptVisible = true">添加部门</el-button>
      </el-tab-pane>
    </el-tabs>

    <!--部门列表-->
    <el-table size="small" :data="listDeptData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" class="user-search">
      <el-table-column align="center" prop="departmentId" label="部门ID" width="100">
      </el-table-column>
      <el-table-column align="center" prop="name" label="部门名称" width="300">
      </el-table-column>
      <!-- <el-table-column align="center" prop="description" label="部门描述" width="300">
      </el-table-column> -->
      
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
          <el-button size="mini" type="primary" @click="onUser(scope.row)">查看用户</el-button>
          <el-button size="mini" type="primary" @click="addUser(scope.row)">添加用户</el-button>
          <el-button size="mini" type="success" @click="onRole(scope.row)">查看角色</el-button>
          <el-button size="mini" type="success" @click="addRole(scope.row)">添加角色</el-button>
          <el-button size="mini" type="danger" @click="deleteDept(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加组织界面 -->
    <el-dialog title="添加组织" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="组织名称" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入组织名称"></el-input>
        </el-form-item>
        <el-form-item label="组织描述" prop="description">
          <el-input size="small" v-model="editForm.description" auto-complete="off" placeholder="请输入组织描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 添加部门界面 -->
    <el-dialog title="添加部门" :visible.sync="editDeptVisible" width="30%" @click="editDeptVisible = false">
      <el-form label-width="120px" :model="editDept" :rules="rules" ref="editDept">
        <el-form-item label="部门名称" prop="name">
          <el-input size="small" v-model="editDept.name" auto-complete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门描述" prop="description">
          <el-input size="small" v-model="editDept.description" auto-complete="off" placeholder="请输入部门描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editDeptVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitDept('editDept')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 查看角色界面 -->
    <el-dialog title="部门角色" :visible.sync="roleVisible" width="50%" @click="roleVisible = false">
      <div v-loading="loading">
        <el-tag
          v-for="tag in DeptRoleData"
          :key="tag.name"
          closable
          @close="handleClose(tag)"
          >
          {{tag.name+'-'+tag.remark}}
        </el-tag>
        <el-tag v-if="DeptRoleData.length == 0">无</el-tag>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="roleVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 添加角色界面 -->
    <el-dialog title="添加部门角色" :visible.sync="addRoleVisible" width="50%" @click="addRoleVisible = false">
        <el-form label-width="120px" v-loading="loading">
          <el-form-item label="角色菜单" prop="parentId">
            <el-select size="small" v-model="roleId" placeholder="请选择" class="selectw">
              <el-option v-for="parm in rmenu" :key="parm.id" :label="parm.name+'-'+parm.remark" :value="parm.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addRoleVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitaddRole">添加</el-button>
      </div>
    </el-dialog>

    <!-- 查看用户界面 -->
    <el-dialog title="部门用户" :visible.sync="userVisible" width="50%" @click="userVisible = false">
      <div v-loading="loading">
        <el-tag
          v-for="tag in DeptUserData"
          :key="tag.name"
          closable
          @close="handleUserDel(tag)"
          >
          {{tag.userName+'-'+tag.remark}}
        </el-tag>
        <el-tag v-if="DeptUserData.length == 0">无</el-tag>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="userVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 添加用户界面 -->
    <el-dialog title="添加用户" :visible.sync="addUserVisible" width="30%" @click="addUserVisible = false">
      <el-form label-width="120px" :model="userName" :rules="userRules" ref="userName">
        <el-form-item label="用户名" prop="name">
          <el-input size="small" v-model="userName.name" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input size="small" v-model="userName.remark" auto-complete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addUserVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitUser('userName')">添加</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { orgList, orgSave, orgDelete , deptList, deptSave,
  deptDelete, deptRoleList, roleList, deptRoleSave,
  deptRoleDelete, deptUserList, deptUserCreate, deptUserDelete } from '../../api/userMG'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //组织编辑页面显示与隐藏
      editDeptVisible: false, //部门
      roleVisible: false, //部门角色
      addRoleVisible: false, //添加部门角色
      userVisible:false, //部门用户
      addUserVisible:false, //添加部门用户
      editForm: {
        name: '',
        description: '',
      },
      editDept: {
        name: '',
        description: '',
      },
      activeName:null,
      userName:{
        name:'',
        remark:''
      },
      // rules表单验证
      rules: {
        name: [ { required: true, message: '请输入名称', trigger: 'blur' }],
        // description: [{ required: true, message: '请输入描述', trigger: 'blur' }]
      },
      userRules: {
        name: [ { required: true, message: '请输入用户名', trigger: 'blur' }],
        // remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      },
      // userparm: [], //搜索权限
      listData: [], //组织数据
      listDeptData: [], //部门数据
      DeptRoleData: [], //角色数据
      DeptUserData: [], //用户数据
      roleId:null,
      departmentId:null,
      rmenu:[],//获取角色菜单
      tags: [ //部门角色数据
          { name: '标签一', type: '' },
          { name: '标签二', type: 'success' },
          { name: '标签三', type: 'info' },
          { name: '标签四', type: 'warning' },
          { name: '标签五', type: 'danger' }
        ]
    }
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取组织列表
    getdata() {
      this.loading = true
      orgList().then(res => {
        console.log(res)

          this.loading = false
          if ( res && res.code == 0 ){
            if(res.data.list.length > 0){
              this.listData = res.data.list
              this.activeName = (res.data.list[0].organizationId).toString() || ''
              this.getDeptdata(res.data.list[0].organizationId)
            }
          }else{
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        })
        .catch(err => {
          console.log(err.message)
          this.loading = false
          this.$message.error('组织加载失败，请稍后再试！')
        })
    },
    // 获取部门列表
    getDeptdata(id) {
      this.loading = true
      deptList(id)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listDeptData = res.data.list
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('部门加载失败，请稍后再试！')
        })
    },
    // 获取部门角色列表
    getDeptRoledata(id) {
      this.DeptRoleData = []
      this.loading = true
      deptRoleList(id)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.DeptRoleData = res.data.list
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('部门加载失败，请稍后再试！')
        })
    },
    // 获取部门用户列表
    getDeptUserdata(id) {
      this.DeptUserData = []
      this.loading = true
      deptUserList(id)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.DeptUserData = res.data.list
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('部门加载失败，请稍后再试！')
        })
    },
    // 切换部门列表
    handleClick(tab) {
        this.getDeptdata(tab.name)
    },
    // 删除组织列表
    handleTabsDelete(targetName, action) {
      if(action == 'add'){
        this.handleOrg()
        return
      }
      this.$confirm('确定要删除该组织吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          orgDelete(targetName)
            .then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
      console.log(targetName, action)
    },
    
    //组织显示编辑界面
    handleOrg: function() {
      this.editForm= {
        name: '',
        description: '',
      }
      this.editFormVisible = true
    },
    
    // 组织编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          orgSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 0) {
                this.getdata()
                this.$message({
                  type: 'success',
                  message: '组织保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('组织保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 添加部门
    submitDept(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          let parems = {
            "name": this.editDept.name,
            "description": this.editDept.description,
            "organizationId": parseInt(this.activeName),
            "leaderId": 0
          }
          deptSave(parems)
            .then(res => {
              this.editDeptVisible = false
              this.loading = false
              if (res.code == 0) {
                this.getDeptdata(this.activeName)
                this.$message({
                  type: 'success',
                  message: '部门保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editDeptVisible = false
              this.loading = false
              this.$message.error('部门保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    
    // 删除部门
    deleteDept(row) {
      console.log(row)
      this.$confirm('确定要删除'+row.name+'吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.departmentId)
            .then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getDeptdata(this.activeName)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    // 展示部门角色
    onRole(row){
      this.roleVisible = true
      this.departmentId = row.departmentId
      this.getDeptRoledata(row.departmentId)
    },
    // 展示部门用户
    onUser(row){
      this.userVisible = true
      this.departmentId = row.departmentId
      this.getDeptUserdata(row.departmentId)
    },
    
    // 获取角色菜单
    getroleList(){
      this.loading = true
      roleList()
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.rmenu = res.data.list
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('角色菜单加载失败，请稍后再试！')
        })
    },
    // 添加部门角色
    addRole(row){
      this.roleId = null
      this.addRoleVisible = true
      this.departmentId = row.departmentId
      this.getroleList(row.departmentId)
    },
    // 添加部门用户
    addUser(row){
      this.userName={
        name:'',
        remark:''
      }
      this.addUserVisible = true
      this.departmentId = row.departmentId
    },
    // 添加部门用户
    submitUser(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.loading = true
          deptUserCreate({userName:this.userName.name,departmentId:this.departmentId,remark:this.userName.remark})
            .then(res => {
              this.loading = false
              if (res.code == 0) {
                console.log(res)
                this.addUserVisible = false
                this.$message({
                  type: 'success',
                  message: '添加用户成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.addUserVisible = false
              this.loading = false
              this.$message.error('添加用户失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 添加部门角色
    submitaddRole(){
      let parms = {
        "departmentId": this.departmentId,
        "roleId": this.roleId
      }
      this.loading = true
      deptRoleSave(parms)
            .then(res => {
              this.loading = false
              if (res.code == 0) {
                this.addRoleVisible = false
                // this.roleVisible = true
                // this.getDeptRoledata(this.departmentId)
                this.$message({
                  type: 'success',
                  message: '添加角色成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.addRoleVisible = false
              this.loading = false
              this.$message.error('添加角色失败，请稍后再试！')
            })
      console.log(parms)
    },
    // 删除角色
    handleClose(tag) {
      console.log(tag.id)
      this.$confirm('确定要删除'+tag.name+'吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            "departmentId": this.departmentId,
            "roleId": tag.id
          }
          deptRoleDelete(params)
            .then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '角色已删除!'
                })
                this.getDeptRoledata(this.departmentId)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('角色删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 删除用户
    handleUserDel(tag) {
      console.log(tag.id)
      this.$confirm('确定要删除'+tag.userName+'吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            "userName":tag.userName,
            "departmentId": this.departmentId
          }
          deptUserDelete(params)
            .then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '用户已删除!'
                })
                this.getDeptUserdata(this.departmentId)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('角色删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.el-tag + .el-tag {
    margin-left: 10px;
  }

/* /deep/ .el-tabs__new-tab{
  color: #fff;
  background-color: #409EFF;
} */
</style>

 


// WEBPACK FOOTER //
// src/views/system/Dept.vue